// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
 .table-responsive {
  overflow-x: auto;
}
mat-table {
  min-width: 1400px;
  width: max-content;
  display: table;
}
th.mat-header-cell, th.text-center {
  font-family: 'Arial', 'Helvetica', sans-serif;
  font-size: 15px;
  font-weight: bold;
  text-transform: capitalize;
  color: #000;
  background: #f8f9fa;
  padding: 12px 8px;
}
.mat-input-element,
input[type="text"].mat-input-element,
input[type="search"].mat-input-element,
th .mat-input-element,
th input[type="text"].mat-input-element {
  font-family: 'Arial', 'Helvetica', sans-serif;
  font-size: 13.5px;
  font-weight: normal;
  font-style: italic;
  color: #b0b0b0;
  border-radius: 4px;
  border: 1px solid #ced4da;
  padding: 4px 8px;
  background: #fff;
  margin-top: 6px;
  margin-bottom: 4px;
  width: 100%;
  box-sizing: border-box;
}
.header-label-sort {
  font-family: 'Arial', 'Helvetica', sans-serif;
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
}
.filter-container {
  margin-top: 5px;
  text-align: center;
}
.header-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}
 
.mat-input-element {
  min-width: 90px;
  max-width: 140px;
  font-size: 13.5px;
}
:host ::ng-deep .my-white-table .mat-row,
:host ::ng-deep .my-white-table tr.mat-row,
:host ::ng-deep .my-white-table .mat-row:nth-child(even),
:host ::ng-deep .my-white-table tr.mat-row:nth-child(even),
:host ::ng-deep .my-white-table .mat-row:nth-child(odd),
:host ::ng-deep .my-white-table tr.mat-row:nth-child(odd),
:host ::ng-deep .my-white-table tbody tr,
:host ::ng-deep .my-white-table tr,
:host ::ng-deep .my-white-table td {
  background: #fff !important;
}

/* Search and filtering improvements */
.search-container {
  position: relative;
}

.search-container input.searching {
  padding-right: 50px;
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.search-spinner {
  position: absolute;
  right: 15px;
  top: 8px;
  z-index: 10;
}

.search-spinner app-spinner {
  display: inline-block;
}

.filtering-indicator {
  display: flex;
  align-items: center;
  color: #6c757d;
  font-style: italic;
}

.filtering-indicator app-spinner {
  margin-right: 8px;
  display: inline-block;
}

/* Table overlay for filtering */
.table-container {
  position: relative;
}

.table-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  backdrop-filter: blur(1px);
}

.overlay-content {
  display: flex;
  align-items: center;
  background: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  color: #495057;
  font-weight: 500;
}

.overlay-content app-spinner {
  display: inline-block;
}

/* Subtle table dimming during filtering */
.my-white-table.filtering {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

/* Smooth transitions */
.search-container input {
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, padding-right 0.15s ease;
}

/* Better visual feedback for active filtering */
.filtering-indicator small {
  animation: pulse-text 1.5s ease-in-out infinite;
}

@keyframes pulse-text {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./projects/tilmanagement/src/app/technical-letters/technical-letters.component.css"],"names":[],"mappings":";CACC;EACC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,6CAA6C;EAC7C,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;;;;EAKE,6CAA6C;EAC7C,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,6CAA6C;EAC7C,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;;;;;;EASE,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,kGAAkG;AACpG;;AAEA,gDAAgD;AAChD;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB","sourcesContent":["\n .table-responsive {\n  overflow-x: auto;\n}\nmat-table {\n  min-width: 1400px;\n  width: max-content;\n  display: table;\n}\nth.mat-header-cell, th.text-center {\n  font-family: 'Arial', 'Helvetica', sans-serif;\n  font-size: 15px;\n  font-weight: bold;\n  text-transform: capitalize;\n  color: #000;\n  background: #f8f9fa;\n  padding: 12px 8px;\n}\n.mat-input-element,\ninput[type=\"text\"].mat-input-element,\ninput[type=\"search\"].mat-input-element,\nth .mat-input-element,\nth input[type=\"text\"].mat-input-element {\n  font-family: 'Arial', 'Helvetica', sans-serif;\n  font-size: 13.5px;\n  font-weight: normal;\n  font-style: italic;\n  color: #b0b0b0;\n  border-radius: 4px;\n  border: 1px solid #ced4da;\n  padding: 4px 8px;\n  background: #fff;\n  margin-top: 6px;\n  margin-bottom: 4px;\n  width: 100%;\n  box-sizing: border-box;\n}\n.header-label-sort {\n  font-family: 'Arial', 'Helvetica', sans-serif;\n  font-size: 15px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n.filter-container {\n  margin-top: 5px;\n  text-align: center;\n}\n.header-flex {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n}\n \n.mat-input-element {\n  min-width: 90px;\n  max-width: 140px;\n  font-size: 13.5px;\n}\n:host ::ng-deep .my-white-table .mat-row,\n:host ::ng-deep .my-white-table tr.mat-row,\n:host ::ng-deep .my-white-table .mat-row:nth-child(even),\n:host ::ng-deep .my-white-table tr.mat-row:nth-child(even),\n:host ::ng-deep .my-white-table .mat-row:nth-child(odd),\n:host ::ng-deep .my-white-table tr.mat-row:nth-child(odd),\n:host ::ng-deep .my-white-table tbody tr,\n:host ::ng-deep .my-white-table tr,\n:host ::ng-deep .my-white-table td {\n  background: #fff !important;\n}\n\n/* Search and filtering improvements */\n.search-container {\n  position: relative;\n}\n\n.search-container input.searching {\n  padding-right: 50px;\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.search-spinner {\n  position: absolute;\n  right: 15px;\n  top: 8px;\n  z-index: 10;\n}\n\n.search-spinner app-spinner {\n  display: inline-block;\n}\n\n.filtering-indicator {\n  display: flex;\n  align-items: center;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.filtering-indicator app-spinner {\n  margin-right: 8px;\n  display: inline-block;\n}\n\n/* Table overlay for filtering */\n.table-container {\n  position: relative;\n}\n\n.table-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  backdrop-filter: blur(1px);\n}\n\n.overlay-content {\n  display: flex;\n  align-items: center;\n  background: white;\n  padding: 12px 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  color: #495057;\n  font-weight: 500;\n}\n\n.overlay-content app-spinner {\n  display: inline-block;\n}\n\n/* Subtle table dimming during filtering */\n.my-white-table.filtering {\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n/* Smooth transitions */\n.search-container input {\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, padding-right 0.15s ease;\n}\n\n/* Better visual feedback for active filtering */\n.filtering-indicator small {\n  animation: pulse-text 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-text {\n  0%, 100% { opacity: 0.7; }\n  50% { opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
